import { render, staticRenderFns } from "./ResetActiveBook.vue?vue&type=template&id=6749d892"
import script from "./ResetActiveBook.vue?vue&type=script&lang=js"
export * from "./ResetActiveBook.vue?vue&type=script&lang=js"
import style0 from "./ResetActiveBook.vue?vue&type=style&index=0&id=6749d892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports